import vueRequest from "./vueAiRequest";
import appConfigs from "@/config.js";
import rsaConfig from "../rsaConfig.js";

let prefix = '/open-ai';

export default prefix;

/**
 * 接口：发送短信验证码（100045)
 * @param phone
 * @returns {Promise<unknown>}
 */
export const sendMsgCodeAPI = ({phone}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}/scrmapi/authentication/sendMsgCode`,
    params: {phone},
    type: "POST",
    apiCode: 100045
});

/**
 * 获取初始参数（100055）
 * @param clientId
 * @returns {Promise<unknown>}
 */
export const getTraceAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/zpzOauthOauthClientDetails/trace`,
    params: {clientId: rsaConfig.clientId},
    type: "POST",
    apiCode: 100055
});
/**
 * 通过授权码code获取微信公众号用户的openId（100002）
 * @param appCode       账号唯一码
 * @param authCode      授权码
 * @returns {Promise<unknown>}
 */
export const getMpOpenIdByCodeAPI = ({appCode, authCode}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/appletAccount/getMpOpenIdByCode`,
    params: {appCode: appConfigs.appId, authCode},
    apiCode: '100002',
    type: "POST",
    isUCode: false,
    isSendRsa: false
});
/**
 * 公众号登录
 * @param openId
 * @returns {Promise<unknown>}
 */
export const wechatOauthTokenAPI = ({openId}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/oauth/token`,
    params: {grant_type: 'password', appCode: appConfigs.appId, scope: 'all', auth_type: 'wemp', openId},
    type: "POST",
    apiCode: 10000001,
    isSendRsa: true, //请求参数是否加密
    isUcode: false,//是否需要登陆
    contentType: 'application/x-www-form-urlencoded' //请求头
});
/**
 * 手机号登录
 * @param password
 * @param mpOpenId
 * @param refresh_token
 * @param username
 * @param inviteCode
 * @returns {Promise<unknown>}
 */
export const oauthTokenAPI = ({password, mpOpenId, refresh_token, username, inviteCode = '', registSouc = ''}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/oauth/token`,
    params: {
        grant_type: 'password', appCode: appConfigs.appId, scope: 'all', auth_type: 'sms',
        password, mpOpenId, refresh_token, username, inviteCode, registSouc
    },
    type: "POST",
    apiCode: 10000001,
    isSendRsa: true, //请求参数是否加密
    isUcode: false,//是否需要登陆
    contentType: 'application/x-www-form-urlencoded' //请求头
});
/**
 * 获取个人登录信息(20231010001) |负责人:赵志龙
 * @returns {Promise<unknown>}
 */
export const userInfoAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/user/info`,
    params: {},
    type: "POST",
    apiCode: 20231010001,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 更新个人信息(20231010002) |负责人:赵志龙
 * @param merchantName      机构名称 [ 上限15字 ]
 * @param trainProgramSet   自选的培训科目
 * @returns {Promise<unknown>}
 */
export const userUpdAPI = ({merchantName, trainProgramSet}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/user/upd`,
    params: {merchantName, trainProgramSet},
    type: "POST",
    apiCode: 20231010002,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 查询我的其他信息(20231010003) |负责人:赵志龙
 * @returns {Promise<unknown>}
 */
export const userOtherInfoAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/user/otherInfo`,
    params: {},
    type: "POST",
    apiCode: 20231010003,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 获取用户会员信息(20231010004) |负责人:赵志龙
 * @returns {Promise<unknown>}
 */
export const userVipInfoAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/user/vipInfo`,
    params: {},
    type: "POST",
    apiCode: 20231010004,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 自选培训类目(20230918004) |负责人:赵志龙
 * @returns {Promise<unknown>}
 */
export const trainProgramAPI = () => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/dict/train/program`,
    params: {},
    type: "POST",
    apiCode: 20230918004,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 会员支付(90001106) |负责人:jinlei
 * @param merchantCode      商户code
 * @param phoneNumber
 * @param productCode       商品编码
 * @param shopCode          门店code
 * @param studentCode
 * @param studentName
 * @param wechatOpenId      微信id
 * @param renewFlag         是否续费订单:0-新订单;1-续费订单
 * @returns {Promise<unknown>}
 */
export const payTicketAPI = ({merchantCode, phoneNumber, productCode, shopCode, studentCode, studentName, wechatOpenId, renewFlag, userCode}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/member/assets/payTicket`,
    params: {
        appId: appConfigs.appId, merchantCode, phoneNumber, productCode, shopCode, studentCode, studentName,
        wechatOpenId, renewFlag, userCode
    },
    type: "POST",
    apiCode: 90001106,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 邀请列表(90001112) |负责人:李金磊
 * @param orderBy
 * @param pageNum
 * @param pageSize
 * @param userCode      用户code
 * @returns {Promise<unknown>}
 */
export const invitedListAPI = ({orderBy, pageNum, pageSize, userCode, payStas}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/member/account/invitedList`,
    params: {orderBy, pageNum, pageSize, userCode, payStas},
    type: "POST",
    apiCode: 90001112,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 邀请次数(90001113) |负责人:李金磊
 * @param orderBy
 * @param pageNum
 * @param pageSize
 * @param userCode
 * @returns {Promise<unknown>}
 */
export const invitedCountAPI = ({orderBy, pageNum, pageSize, userCode}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/member/account/invitedCount`,
    params: {orderBy, pageNum, pageSize, userCode},
    type: "POST",
    apiCode: 90001113,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 获取多个字典（70000004） |负责人：
 * @param dictTypeList
 * @returns {Promise<unknown>}
 */
export const getMultiDictAPI = ({dictTypeList = []}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/sysDict/getMultiDict`,
    params: {dictTypeList},
    type: "POST",
    apiCode: 70000004,
    isSendRsa: false, //请求参数是否加密
    isUcode: false,//是否需要登陆
});

/**
 * 查询用户参数使用记录(20231030002) |负责人:赵志龙
 * @param formParaCode      参数编码
 * @param orderBy
 * @param pageNum
 * @param pageSize
 * @param paraName          参数名称
 * @param promptCfgCode     表单参数业务编码
 * @param wxOpenId          微信openID
 * @returns {Promise<unknown>}
 */
export const rcdQueryAPI = ({formParaCode, orderBy, pageNum, pageSize, paraName, promptCfgCode, wxOpenId}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/para/rcd/query`,
    params: {formParaCode, orderBy, pageNum, pageSize, paraName, promptCfgCode, wxOpenId},
    type: "POST",
    apiCode: 20231030002,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});
/**
 * 删除参数使用记录(20231030001) |负责人:赵志龙
 * @param paraRcdCode
 * @returns {Promise<unknown>}
 */
export const rcdDelAPI = ({paraRcdCode}) => vueRequest({
    apiUrl: `${appConfigs.urlWebHttp}${prefix}/ai/para/rcd/del`,
    params: {paraRcdCode},
    type: "POST",
    apiCode: 20231030001,
    isSendRsa: true, //请求参数是否加密
    isUcode: true,//是否需要登陆
});



// WEBPACK FOOTER //
// ./src/modle/login.js